import { render, staticRenderFns } from "./BestSellingProducts.vue?vue&type=template&id=715dcd5e&scoped=true&"
import script from "./BestSellingProducts.vue?vue&type=script&lang=js&"
export * from "./BestSellingProducts.vue?vue&type=script&lang=js&"
import style0 from "./BestSellingProducts.vue?vue&type=style&index=0&id=715dcd5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715dcd5e",
  null
  
)

export default component.exports